// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-param-reassign */
import BaseRESTSerializer from '@square/dashboard-data/serializers/base-rest-serializer';
import { v4 as uuid } from 'uuid';
export default BaseRESTSerializer.extend({
  primaryKey: 'id',
  // Override default keyForAttribute
  keyForAttribute(attr) {
    return attr;
  },
  extractMeta(store, typeClass, payload) {
    const meta = {};
    if (payload && Object.prototype.hasOwnProperty.call(payload, 'paginationToken')) {
      meta.paginationToken = payload.paginationToken;
      delete payload.paginationToken;
    }
    if (payload && Object.prototype.hasOwnProperty.call(payload, 'queryToken')) {
      meta.queryToken = payload.queryToken;
      delete payload.queryToken;
    }
    return meta;
  },
  normalizeArrayResponse(store, primaryModelClass, payload, id, requestType) {
    // rename attribute so that the serializer can find the right model
    payload.universalCatalogItem = payload.items;
    delete payload.items;

    // Give each item a temporary (session-only) ID
    payload.universalCatalogItem.forEach(item => {
      item.id = uuid();
    });
    return this._super(store, primaryModelClass, payload, id, requestType);
  }
});